export const LineOfBusinessesBrandingColors = {
    S4A: {
        headerBackgroundColor: '#3629ed',
        headerColor: '#fff',
        fabBackgroundColor: '#3629ed',
        fabColor: '#fff',
        messageIconColor: '#3629ed',
        primaryMessageBubbleBackgroundColor: '#3629ed',
        primaryMessageBubbleTextColor: '#fff',
        buttonHoverBackgroundColor: '#3629ed',
        buttonHoverTextColor: '#fff',
    },
    S4A_STAGING: {
        headerBackgroundColor: '#3629ed',
        headerColor: '#fff',
        fabBackgroundColor: '#3629ed',
        fabColor: '#fff',
        messageIconColor: '#3629ed',
        primaryMessageBubbleBackgroundColor: '#3629ed',
        primaryMessageBubbleTextColor: '#fff',
        buttonHoverBackgroundColor: '#3629ed',
        buttonHoverTextColor: '#fff',
    },
    S4P: {
        headerBackgroundColor: '#9691FF',
        headerColor: '#220287',
        fabBackgroundColor: '#9691FF',
        fabColor: '#220287',
        messageIconColor: '#9691FF',
        primaryMessageBubbleBackgroundColor: '#220287',
        primaryMessageBubbleTextColor: '#fff',
        buttonHoverBackgroundColor: '#220287',
        buttonHoverTextColor: '#fff',
    },
    S4P_STAGING: {
        headerBackgroundColor: '#9691FF',
        headerColor: '#220287',
        fabBackgroundColor: '#9691FF',
        fabColor: '#220287',
        messageIconColor: '#9691FF',
        primaryMessageBubbleBackgroundColor: '#220287',
        primaryMessageBubbleTextColor: '#fff',
        buttonHoverBackgroundColor: '#220287',
        buttonHoverTextColor: '#fff',
    },
    CONSUMER: {
        headerBackgroundColor: '#21D05F',
        headerColor: '#000000',
        fabBackgroundColor: '#21D05F',
        fabColor: '#fff',
        messageIconColor: '#25C95E',
        primaryMessageBubbleBackgroundColor: '#25C95E',
        primaryMessageBubbleTextColor: '#000000',
        buttonHoverBackgroundColor: '#21D05F',
        buttonHoverTextColor: '#000000',
    },
    CONSUMER_STAGING: {
        headerBackgroundColor: '#21D05F',
        headerColor: '#000000',
        fabBackgroundColor: '#21D05F',
        fabColor: '#fff',
        messageIconColor: '#25C95E',
        primaryMessageBubbleBackgroundColor: '#25C95E',
        primaryMessageBubbleTextColor: '#000000',
        buttonHoverBackgroundColor: '#21D05F',
        buttonHoverTextColor: '#000000',
    },
};
